export default __webpack_public_path__ + "assets/images/aa1cc1da4548f7b387fadd1f30382a8d.svg";